export const INFORMATION_TAB_KEY = "basic-information";
export const FOCUS_ACCORDION_PARAM = "focusAccordion";

/** Accordion `eventKey` values on the Basic Information tab. */
export const INFORMATION_ACCORDIONS = {
    REQUIRED_APPROVALS: "required-approvals",
    DATA_FLOW: "data-flow",
    ATTACHMENTS: "attachments",
};

/**
 * @param {string|null|undefined} accordionKey
 * @returns {URLSearchParams}
 */
export const buildInformationTabSearchParams = (accordionKey) => {
    const params = new URLSearchParams();

    params.set("tab", INFORMATION_TAB_KEY);

    if (accordionKey) {
        params.set(FOCUS_ACCORDION_PARAM, accordionKey);
    }

    return params;
};

/**
 * @param {string|number} assetId
 * @param {string|null|undefined} accordionKey
 * @returns {string}
 */
export const buildInformationTabPath = (assetId, accordionKey) => {
    const params = buildInformationTabSearchParams(accordionKey);

    return `/admin/data-protection/softwares/${assetId}?${params.toString()}`;
};

/**
 * @param {string} search
 * @returns {{ focusAccordion: string|null }}
 */
export const readFocusAccordionFromSearch = (search = "") => {
    const params = new URLSearchParams(search);

    return {
        focusAccordion: params.get(FOCUS_ACCORDION_PARAM),
    };
};

const escapeCssValue = (value) => {
    const text = String(value);

    if (typeof CSS !== "undefined" && CSS.escape) {
        return CSS.escape(text);
    }

    return text.replace(/"/g, '\\"');
};

export const focusInformationAccordion = (
    accordionKey,
    { highlightMs = 4500 } = {}
) => {
    if (typeof document === "undefined" || !accordionKey) {
        return false;
    }

    const element = document.querySelector(
        `[data-information-accordion="${escapeCssValue(accordionKey)}"]`
    );

    if (!element) {
        return false;
    }

    const target =
        element.querySelector(".accordion-button")
        || element.querySelector(".accordion-header")
        || element;

    target.classList.add("information-accordion-focus-highlight");
    target.style.scrollMarginTop = "120px";
    target.scrollIntoView({
        behavior: "smooth",
        block: "start",
    });

    window.setTimeout(() => {
        target.classList.remove("information-accordion-focus-highlight");
    }, highlightMs);

    return true;
};
